import {Component} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";
import {inject} from "../../services/di";
import {ConfigService, RuntimeConfig} from "../../services/ConfigService";
import {AnalyticsService} from "../../services/AnalyticsService";
import {icons} from "../../icons/Icons";
import {HistoryService} from "../../services/HistoryService";

@element("circular-destination-handler-element")
export class CircularDestinationHeader extends Component<{}, {}> {
	@inject config: ConfigService;
	@inject analytics: AnalyticsService;
	@inject history: HistoryService;

	render () {
		return <div>
			<a class="publisher-back" href={this.config.CDP_BACK_LINK} onClick={this._handleBackClick}>
				{icons.backArrow}
				{i18n("cdpv3_back", {"site": this.config.CDP_PUBLISHER_NAME})}
			</a>
			<div class="powered-by-flipp">{i18n("cdpv3_powered_by")} <strong>Flipp</strong></div>
		</div>;
	}

	onAttach () {
		if (!this.config.CDP_VISIBLE_SENT) {
			this.config.CDP_VISIBLE_SENT = true;
			this.analytics.trackPublisherBackButtonVisible(this.config.CDP_PUBLISHER_NAME);
		}
	}

	private _handleBackClick = (e: Event) => {
		this.analytics.trackPublisherBackButtonClick(this.config.CDP_PUBLISHER_NAME);
		this.history.prepareDistState();
		const link = e.target as HTMLLinkElement;
		e.preventDefault();
		window.location.href = link.href;
	}
}
